import React, {useState} from 'react';
import {Box} from '@mui/material';
import style from './CalendarList.module.css'
import Days from "../Days";
import Doctors from "../Doctors";
import {getAllDaysInMonth} from "../../common/getAllDaysInMonth";

const CalendarList = () => {
    const now = new Date();
    const days = getAllDaysInMonth(now.getFullYear(), now.getMonth(), now.getMonth() + 1, now);
    const [portion, setPortion] = useState(days.slice(0, 22))
    return (
        <Box className={style.main2}>
            <Box sx={{display: "flex", alignItems: "center"}}>
                <div style={{width: "20%", flexFlow: "column", flexGrow: 1}}>

                </div>
                <div style={{width: "80%", flexFlow: "column", flexGrow: 1}}>
                    <Days portion={portion} setPortion={setPortion}/>
                </div>
            </Box>
            <Box sx={{display: "flex", borderTop: "1px solid #c9c7c7", flexDirection: "column"}}>
                <Doctors portion={portion}/>
            </Box>
        </Box>
    );
};

export default React.memo(CalendarList);